import './sampler-ineligible-dialog.css'

customElements.whenDefined('x-drawer').then((Drawer) => {
  class SamplerIneligibleDialog extends Drawer {
    #backButton = null
    #boundHandleBack = null

    constructor() {
      super()
      this.#boundHandleBack = () => this.hide()
    }

    get openFrom() {
      return 'top'
    }

    _setInitialPosition() {
      this.style.top = '0px'
      this.style.left = '0px'
      this.style.right = '0px'
      this.style.bottom = '0px'
    }

    connectedCallback() {
      super.connectedCallback()
      this.render()
    }

    disconnectedCallback() {
      this.#removeEventListeners()
    }

    #attachEventListeners() {
      this.#backButton = this.querySelector('.ineligible-dialog__back')
      this.#backButton?.addEventListener('click', this.#boundHandleBack)
    }

    #removeEventListeners() {
      this.#backButton?.removeEventListener('click', this.#boundHandleBack)
    }

    render() {
      const customerName = this.dataset.customerName || ''
      const nameText = customerName ? `, ${customerName}` : ''

      this.innerHTML = `
        <div slot="header" class="v:hidden">
          <h2 class="v:h5 v:l:h4">Ineligible for Sampler</h2>
        </div>
        <div class="v:flex v:flex-col v:gap-6 v:px-5 v:pt-4 v:pb-10 v:l:px-[50px] v:l:py-10 v:text-center">
          <h2 class="v:h5 v:l:h4">Welcome back${nameText}! Thanks for returning to Viva.</h2>
          <p class="v:text-body">
            Sorry, this offer is only available for your first order.
          </p>
          <div class="v:flex v:justify-center v:pt-2">
            <button type="button" class="button v:button--primary v:button--md ineligible-dialog__back">
              Back
            </button>
          </div>
        </div>
      `

      this.#attachEventListeners()
    }
  }

  if (!customElements.get('sampler-ineligible-dialog')) {
    customElements.define('sampler-ineligible-dialog', SamplerIneligibleDialog)
  }
})
